import { OptionCl } from "../../../components/select-cl"
import { NOMINALCURRENCY_DOMAIN, SECURITY_PHYSICAL_FORM, INSTRUMENT_CATEGORY_DOMAIN, CFFFLAG_DOMAIN, PRINCIPAL_TRANSFER_AGENT, ISIN_PER_CTRY_DOMAIN, 
         CSD_OF_ISSUANCE_DOMAIN, ISMAG_ADHERENCE_DOMAIN, COUNTRY_OF_TAX_DOMAIN, TAX_SPECIFICITY_DOMAIN, CBF_CUSTODY_TYPE_DOMAIN} from "./sagas"

export type SecurityCriteriaState = {
    allDomainsLoaded: boolean,
    error?: string,
    nominalCurrencies?: OptionCl[] ,
    securityPhysForms?: OptionCl[],
    instrumentCategories?: OptionCl[],
    cffQualified? :OptionCl[],
    principalTransferAgent?: OptionCl[],
    isinPerCtry? : OptionCl[],
    isins?: OptionCl[],
    csdOfIssuance?: OptionCl[],
    IsmagAdherence?: OptionCl[],
    ctryOfTax?: OptionCl[],
    taxSpecificity?: OptionCl[],
    cbfCustodyType?: OptionCl[]
}

export  type SecurityCriteriaAction =
    { type: "SecurityCriteria/DOMAINLOADED",  payload: OptionCl[], domain: string } | 
    { type: "SecurityCriteria/FETCHERROR", payload: string }
  
    const initialState: SecurityCriteriaState = { allDomainsLoaded: false }

    const getAllDomainsLoaded = ( state : SecurityCriteriaState ) : boolean => {
        //console.log( "Security criteria reducer.ts in getAllDomainsLoaded "  + JSON.stringify(state) + " tms:" + Date.now() )
        return (typeof state.nominalCurrencies !== "undefined") && (state.nominalCurrencies !== null ) 
            && (typeof state.securityPhysForms !== "undefined") && (state.securityPhysForms !== null )
            && (typeof state.instrumentCategories !== "undefined") && (state.instrumentCategories !== null )
            && (typeof state.cffQualified !== "undefined") && (state.instrumentCategories !== null )
            && (typeof state.principalTransferAgent !== "undefined") && (state.principalTransferAgent !== null )            
            && (typeof state.isinPerCtry !== "undefined") && (state.isinPerCtry !== null )            
            && (typeof state.csdOfIssuance !== "undefined") && (state.csdOfIssuance !== null )            
            && (typeof state.IsmagAdherence !== "undefined") && (state.IsmagAdherence !== null ) 
            && (typeof state.ctryOfTax !== "undefined") && (state.ctryOfTax !== null )
            && (typeof state.taxSpecificity !== "undefined") && (state.taxSpecificity !== null )
            && (typeof state.cbfCustodyType !== "undefined") && (state.cbfCustodyType !== null )
    }


export const securityCriteriaReducer = (
        state: SecurityCriteriaState = initialState,
        action: SecurityCriteriaAction 
    ) => {
        switch (action.type) {
            case "SecurityCriteria/DOMAINLOADED":
                //console.log("Security Criteria Reducer.ts state" + JSON.stringify(state, null, 2) + "action.type is "+action.type+" tms:" + Date.now())
                //console.log("Ccb Criteria Reducer.ts received action" + JSON.stringify(action) + " tms:" + Date.now())
                if ( action.domain === NOMINALCURRENCY_DOMAIN) {  
                    const newState = { ...state, nominalCurrencies: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === SECURITY_PHYSICAL_FORM ) {
                    const newState = { ...state, securityPhysForms: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === INSTRUMENT_CATEGORY_DOMAIN) {
                    const newState = { ...state, instrumentCategories: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === CFFFLAG_DOMAIN ) {
                    const newState = { ...state, cffQualified: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === PRINCIPAL_TRANSFER_AGENT ) {
                    const newState = { ...state, principalTransferAgent: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === ISIN_PER_CTRY_DOMAIN ) {
                    const newState = { ...state, isinPerCtry: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === CSD_OF_ISSUANCE_DOMAIN ) {
                    const newState = { ...state, csdOfIssuance: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;                    
                } else if ( action.domain === ISMAG_ADHERENCE_DOMAIN ) {
                    const newState = { ...state, IsmagAdherence: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;                   
                } else if ( action.domain === COUNTRY_OF_TAX_DOMAIN ) {
                    const newState = { ...state, ctryOfTax: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;                                        
                } else if ( action.domain === TAX_SPECIFICITY_DOMAIN ) {
                    const newState = { ...state, taxSpecificity: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;                                        
                } else if ( action.domain === CBF_CUSTODY_TYPE_DOMAIN ) {
                    const newState = { ...state, cbfCustodyType: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;                                        
                } else {
                    console.warn("Security Criteria reducer.ts: Unrecognized domain [" + action.domain + "]")
                    return state;
                }
                //return { ...state, countries: action.payload, allDomainsLoaded: true }
            case "SecurityCriteria/FETCHERROR" :    
                return {
                    ...state,
                    allDomainsLoaded: false,
                    error: action.payload
                  };
            default: return state;
        }
    }
    